/**
 * Commande en attente d'une recharge Bancontact.
 *
 * Quand le portefeuille ne couvre pas la commande, le récapitulatif ouvre la
 * recharge ; Stripe quitte alors l'app pour la banque, puis revient sur
 * /wallet-success. Le panier, les créneaux, l'adresse et la note survivent
 * (redux-persist) ; seul le téléphone saisi sur la page serait perdu. On le
 * garde ici, et la présence de l'entrée dit « confirmer la commande au
 * retour ».
 */

const KEY = "walletOrder";

/** Page de retour Stripe : celle du site en cours, pas une URL figée. */
export const walletReturnUrl = () => `${window.location.origin}/wallet-success`;

export const savePendingWalletOrder = ({ phone = "" } = {}) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ phone }));
  } catch (err) {
    /* Stockage indisponible : la recharge marche, la commande reste à confirmer. */
  }
};

export const readPendingWalletOrder = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
};

export const clearPendingWalletOrder = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (err) {
    /* rien à faire */
  }
};
